import { render, staticRenderFns } from "./OrderDeliveryTracking.vue?vue&type=template&id=c4bb4d08&"
import script from "./OrderDeliveryTracking.vue?vue&type=script&lang=ts&"
export * from "./OrderDeliveryTracking.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports